import Dialog from './Dialog'

export default Dialog
// eslint-disable-next-line import/export
export * from './Dialog'
